import axios from 'axios'

const StudentComplaintService = {
  async file (data) {
    return axios.post('shared/complaints/file', data)
  },

  async myComplaints (params = {}) {
    return axios.get('shared/complaints/my-complaints', { params })
  },

  async get (id) {
    return axios.get(`shared/complaints/${id}`)
  },

  async uploadAttachment (id, file) {
    const formData = new FormData()
    formData.append('attachment', file)

    return axios.post(`shared/complaints/${id}/attachment`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  async withdraw (id) {
    return axios.delete(`shared/complaints/${id}/withdraw`)
  }
}

export default StudentComplaintService
